import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { WebcamComponentComponent } from '../webcam-component/webcam-component.component';

@Component({
  selector: 'app-select-photo-modal',
  templateUrl: './select-photo-modal.component.html',
  styleUrls: ['./select-photo-modal.component.scss']
})
export class SelectPhotoModalComponent implements OnInit {
  image: any;
  fileName: any;
  constructor(public dialog: MatDialog, public dialogRef: MatDialogRef<SelectPhotoModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    console.log('data', this.data)
  }

  onFileSelected(event: any): void {
    const inputElement = <HTMLInputElement>event.target;
    const files = inputElement.files;

    if (files) {

      // const file = event.target.files[0];
      // this.fileName = file ? file.name : '';

      for (let i = 0; i < files.length; i++) {
        const file = files.item(i);
        if (file) {
          this.fileName = file ? file.name : '';
          let reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = async (event: any) => {
            this.image = event.target.result;
          };
        }
      }
    }

  }

  onSubmit() {
    this.dialogRef.close(this.image);
  }

  openDialog() {
    const dialogRef = this.dialog.open(WebcamComponentComponent, {
      maxWidth: '30vw',
      // minWidth: 'fit-content',

    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.image = result
        this.dialogRef.close(result);
        console.log(`Dialog result: ${result}`);
      }
    });
  }

}
